import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '../../static';

type HeaderProps = {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  flex?: boolean;
  title: string;
  subtitle: string;
};

const Container = styled.section`
  width: 100%;
  color: ${Colors.white};
`;

const Children = styled.section`
  height: 100%;
  border-bottom-right-radius: 200px;
  background-color: ${Colors.blue};
  padding: 15px 5px 10px 30px;

  &.flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

const TitleContainer = styled.section<{ hasChildren?: boolean }>`
  display: flex;
  flex-direction: column;
  text-transform: uppercase;

  .subtitle {
    font-weight: 400;
    font-size: ${(props) => (props.hasChildren ? '10px' : '15px')};
  }

  .title {
    font-weight: 900;
    font-size: ${(props) => (props.hasChildren ? '40px' : '60px')};

    @media (max-width: 1700px) {
      font-size: ${(props) => (props.hasChildren ? '35px' : '52px')};
    }
  }
`;

export const Header = ({ children, className = '', flex, title, subtitle }: HeaderProps) => {
  const hasChildren = React.Children.toArray(children).length > 0;

  return (
    <Container>
      <Children className={flex ? `${className} flex` : className}>
        <TitleContainer hasChildren={hasChildren}>
          <span className='subtitle'>{subtitle}</span>
          <span className='title'>{title}</span>
        </TitleContainer>
        {children}
      </Children>
    </Container>
  );
};
